// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"MainContent_mainContent__1ZpSz"};